(() => {
  const root = document.getElementById('ptd-treat20');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const start = Date.parse(root.dataset.start);
  const end = Date.parse(root.dataset.end);
  const active = () => Number.isFinite(start) && Number.isFinite(end) && Date.now() >= start && Date.now() < end;
  const dialog = root.querySelector('dialog');
  const preview = root.dataset.preview === 'true';
  const key = 'ptd-treat20-2026-11-03-shown';
  let timer;
  let observer;
  let ended = false;
  let otherFormOpen = false;
  let previousFocus;
  const seen = () => {
    try { return sessionStorage.getItem(key) === '1'; } catch { return true; }
  };
  const consent = () => preview || window.Shopify?.customerPrivacy?.marketingAllowed?.() === true;
  const dismiss = () => { if (dialog.open) dialog.close(); previousFocus?.focus?.(); };
  const expire = () => {
    ended = true;
    clearTimeout(timer);
    observer?.disconnect();
    dismiss();
    root.remove();
  };
  if (!active()) { expire(); return; }
  if (seen()) return;
  const collision = () => otherFormOpen || [...document.querySelectorAll('dialog[open], [aria-modal="true"]')].some(element => {
    const style = getComputedStyle(element);
    return element.getClientRects().length > 0 && style.visibility !== 'hidden' && style.visibility !== 'collapse' && style.opacity !== '0' && !element.closest('[aria-hidden="true"], details:not([open])');
  });
  const show = () => {
    if (ended || !active()) { expire(); return; }
    if (!consent() || seen() || document.visibilityState === 'hidden' || collision()) return;
    if (!preview && !root.querySelector('[data-klaviyo-slot]')?.childElementCount) return;
    try { sessionStorage.setItem(key, '1'); } catch { return; }
    previousFocus = document.activeElement;
    dialog.showModal();
    root.querySelector('.ptd-treat20-close').focus();
  };
  const prepare = () => {
    if (ended || !active()) return;
    const slot = root.querySelector('[data-klaviyo-slot]');
    if (!consent()) {
      dismiss();
      observer?.disconnect();
      observer = undefined;
      if (slot) { slot.replaceChildren(); slot.removeAttribute('class'); }
      return;
    }
    if (slot && !slot.className) slot.className = `klaviyo-form-${root.dataset.formId}`;
    if (slot && !observer) {
      observer = new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(show, 8000); });
      observer.observe(slot, { childList:true, subtree:true });
    }
    clearTimeout(timer);
    timer = setTimeout(show, 8000);
  };
  root.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', dismiss));
  root.querySelector('[data-copy]').addEventListener('click', async () => {
    const status = root.querySelector('[data-status]');
    try { await navigator.clipboard.writeText('TREAT20'); status.textContent = status.dataset.success; }
    catch { status.textContent = status.dataset.failure; }
  });
  window.addEventListener('klaviyoForms', event => {
    if (event.detail?.formId === root.dataset.formId) return;
    if (event.detail?.type === 'open') { otherFormOpen = true; dismiss(); }
    if (['close', 'submit'].includes(event.detail?.type)) { otherFormOpen = false; prepare(); }
  });
  document.addEventListener('visitorConsentCollected', prepare);
  document.addEventListener('visibilitychange', () => { if (!active()) expire(); else prepare(); });
  window.addEventListener('pageshow', () => { if (!active()) expire(); });
  setTimeout(expire, end - Date.now());
  prepare();
})();
